export const Prices = [
  {
    _id: 0,
    name: "Below ₹500",
    array: [0, 499]
  },
  {
    _id: 1,
    name: "₹500 to ₹999",
    array: [500, 999]
  },
  {
    _id: 2,
    name: "₹1000 to ₹1999",
    array: [1000, 1999]
  },
  {
    _id: 3,
    name: "₹2000 to ₹4999",
    array: [2000, 4999],
  },
  {
    _id: 4,
    name: "₹5000 to ₹9999",
    array: [5000, 9999],
  },
  {
    _id: 5,
    name: "₹10000 or More",
    array: [10000, 99999999],
  },
];
